define('fukit/view/common/page.resource.error.message.view',['require','exports','module','underscore','uikit/uikit','backbone.radio','datakit/util/getobject'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      UIKit     = require('uikit/uikit'),
      Radio     = require('backbone.radio'),
      getobject = require('datakit/util/getobject');

  var PageResourceErrorView = UIKit.Message.extend({
    options: function() {
      return _.extend({}, UIKit.Message.prototype.options, {
        collection: new Backbone.Collection(),
        format: 'error',
        visible: false,
        dismissable: true,
        childBindings: {
          text: 'message',
        },
      });
    },

    initialize: function() {
      var self = this;

      UIKit.Message.prototype.initialize.apply(this, arguments);

      this.once('before:render', function() {
        var controller = Radio.channel('AppKit.controllerService').request('controller');
        _.each(
          _.result(controller, 'resources'),
          function(resource) {
            this.listenTo(resource, 'error', this.onResourceError);
          },
          this
        );
      });

      Radio.channel('validations.summaryView').on('setVisibility', function(visibility) {
        if (self.clearErrorMessagesOnSync) {
          self.visible = visibility;
        }
      });
    },

    onChangeVisible: function() {
      if (!this.visible) {
        this.collection.reset();
      }
    },

    onResourceError: function(model, err, options) {
      //prettier-ignore
      var allErrors = getobject.get(err, 'xhr.responseJSON.errors') || [],
          errors = this.useFieldValidationMessages ? allErrors : this._removeFieldValidationErrors(errors);

      if (_.isArray(errors)) {
        if (errors.length > 0) {
          if (this.clearPreviousErrorMessages) {
            this.collection.reset();
          }
          this.collection.add(errors);
          this.visible = true;
        }
        if (errors.length == 0 && this.clearPreviousErrorMessages) {
          this.visible = false;
        }
      }
    },

    _removeFieldValidationErrors: function(errors) {
      return _.reject(errors, function(error) {
        return typeof error.field !== 'undefined';
      });
    },
  });

  module.exports = PageResourceErrorView;
});

